module.exports = __webpack_public_path__ + "img/1f98d.e9d01b6.svg";